export default __webpack_public_path__ + "static/media/docs2.b3e7e8fc.svg";